/*
 * Confidential and Proprietary.
 * Do not distribute without Bloom Harbor Gifts consent.
 * Copyright Bloom Harbor Gifts 2019. All rights reserved.
 */

import { createContext } from 'react';

const GfAndGnavAbTestContext = createContext();

export default GfAndGnavAbTestContext;
